// styles for Sidebar
import { MainBackground } from "../assets/imgs";
import { Box, Button, Typography, TextField, outlinedInputClasses, inputLabelClasses } from '@mui/material';
import { styled } from '@mui/material/styles';
import { TextareaAutosize as BaseTextareaAutosize } from '@mui/base/TextareaAutosize';

import "@fontsource/righteous";
const SidebarContainer = styled(Box)`
  background: linear-gradient(180deg, #FFF8D2 0%, rgba(255, 249, 215, 0.888037) 39.32%, rgba(255, 255, 255, 0) 100%);
  height: 100vh;
  width: 250px;
  position: fixed;
  font-family: 'Righteous';
  font-style: normal;
  // font-weight: bolder;
  font-size: 25px; 
  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);  
  box-sizing: border-box;
`
const SidebarContainerItem = styled(Box)`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 10px 14px 8px 32px;
    cursor: pointer;
`

const SelectSidebarContainerItem = styled(Box)`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background: linear-gradient(90deg, #FAFD6F 3.04%, rgba(255, 199, 0, 0) 100%);
    padding: 10px 14px 8px 32px;
    cursor: pointer;
`
const inactiveStyle = {
  textShadow: 'none',
  color: '#907E50',
  background: 'none'
}

// styles for Top Navigation Bar 
const NavigationContainer = styled(Box)`
  height: 62px;
  display: flex;
  flex-direction: row;
  backgroundColor: white;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  // width: 100%;
`

// styles for Top Navigation Bar 
const NavigationToggleButton = styled(Box)`
  margin-left: 15px;
  margin-top: 15px;
  cursor: pointer;
`

const NavigationSideContainer = styled(Box)`
  display: flex;
  align-items: center;
  height: 60px;
`

const NavigationSideButton = styled(Box)`
  display: flex;
  flex-direction: row;
  line-height: 100%;
  align-items: center;
  cursor: pointer;
  padding-left: 30px;
  padding-right: 20px;
`

// styles for cube information overlay
const OverlayBaseContainer = styled(Box)`
  /* Reference: https://www.w3schools.com/howto/howto_css_overlay.asp */
  position: fixed; /* Sit on top of the page content */
  display: none; /* Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5); /* Black background with opacity */
  z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */  
`

const OverlayActiveStyle = {
  display: 'flex',
  // flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center'
}

const OverlayContentContainer = styled(Box)`
  background: #FCFFDD;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
  width: calc(225px + 35vw);
  padding-top: 12px;
  padding-left: 37px;
  padding-right: 40px;
  padding-bottom: 41px;
  position: relative;
`
const OverlayEditContentContainer = styled(Box)`
  background: #DCFFD74D;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
  width: calc(225px + 35vw);
  height: 80vh;

  position: relative;
`

const OverlayContentHeading = styled(Box)`
  font-family: 'Righteous';
  font-style: normal;
  font-weight: 400;
  font-size: calc(17px + 0.4vw);
  margin-bottom: 18px;
`

const OverlayContentListItem = styled(Box)`
  // column-width: 14.3vw;
  column-width: calc(80px + 10.3vw);
  border-bottom: solid 1px #00CDFF;
  font-size: calc(12px + 0.4vw);
`

const OverlayCloseLogo = styled(Box)`
  position: absolute;
  top: 18px;
  right: 0.85vw;
`

const CloseLogo = styled(Box)`
  position: absolute;
  top: 2px;
  right: 0.85vw;
`

// styles for container containing the seconds of countdown 
const CountdownBaseContainer = styled(Box)`
  position: absolute;
  top: 0;
  right: 0;
`

const CountdownContainerPaddingStyle = {
  paddingLeft: '45px',
  paddingRight: '45px',
  opacity: 0.85,
  paddingTop: '0px',
  paddingBottom: '0px',
  fontSize: 'calc(12px + 0.35vw)',
  alignItems: 'center'
}

const BackgroundContainer = styled(Box)`
  background-image: url(${MainBackground});
  background-size: cover;
  // width: 100vw;
  width: 100%;
  height: calc(100vh - 62px);
  @media (max-width: 1680px) {
    /* Styles for small screens */
    height: calc(100vh + 100px);
  }
  @media (max-width: 800px) {
    /* Styles for small screens */
    height: calc(100vh + 500px);
  }
  @media (max-width: 500px) {
    /* Styles for small screens */
    height: calc(100vh + 300px);
  }
`;

const BigContainer = styled(Box)`
  height: 39.5vh;
  border-radius: 10px;
  overflow: auto; 
`;

const SmallContainer = styled(Box)`
  height: 10vh;
  margin: 5px;
  border-radius: 10px;
`;

const LongContainer = styled(Box)`
  height: 18vh;
  // margin: 5px;
  margin-left: 5px;
  margin-right: 5px;
  border-radius: 10px;
  margin-right: 5px;
  margin-left: 5px;
  border-style: solid;
  border: 5px solid transparent;
`;

const ListContainer = styled(Box)`
  border-radius: 20px;
  border-style: solid;
  border: transparent;
  // margin: 5px;
  margin-left: 5px;
  margin-right: 5px;
`;

// margin: 5px;
// border: 5px solid transparent;
const RemainingContainer = styled(ListContainer)`
  height: auto;
  border-radius: 20px;
  border-style: solid;
  border: transparent;
`;

const NGListContainer = styled(ListContainer)`
  margin: 5px;
  border-radius: 10px;
  border-style: solid;
  border: 5px solid transparent;
`;

const ReviseContainer = styled(ListContainer)`
  border-radius: 20px;
  border-style: solid;
  border: solid transparent;
`;

const GreenSmallContainer = styled(SmallContainer)`
  background: linear-gradient(180deg, #C9FF72, #D9D9D900);
  margin: 0px;
  width: 0vh;
  height: auto;
`;

const OrangeSmallContainer = styled(SmallContainer)`
  background: linear-gradient(180deg, #FFC672, #D9D9D900);
  margin: 0px 0px 0px 5px;
  width: 0vh;
  height: auto;
`;

const YellowSmallContainer = styled(LongContainer)`
  background: linear-gradient(180deg, #FFF8B5, #FFFBD200);
  border-image: linear-gradient(45deg, #FFE27DCC, #FFFEDECC);
  border-image-slice: 1;
  width: 0vh;
  height: auto;
`;

const BlueSmallContainer = styled(LongContainer)`
  background: linear-gradient(180deg, #CBEAFA, #FFFFFF00);
  border-image: linear-gradient(45deg, #4EC4DECC, #DEF6FBCC);
  border-image-slice: 1;
  width: 0vh;
  height: auto;
`;

const PinkSmallContainer = styled(LongContainer)`
  background: linear-gradient(180deg, #FFEDED, #FFFBD200);
  border-image: linear-gradient(45deg, #F09B9B, #FFEDED);
  border-image-slice: 1;
  width: 0vh;
  height: auto;
`;

const CEDDSmallContainer = styled(LongContainer)`
  background: linear-gradient(180deg, #DCFFD7, #FFFFFF00);
  border-image: linear-gradient(45deg, #95D330, #DCFFD7);
  border-image-slice: 1;
  width: 0vh;
  height: auto;
`;

const TestResultContainer = styled(Box)`
  height: 80vh;
  border-radius: 10px;
  overflow: auto; 
  background-color: #FFFFFF;
  width: 100%;
  position: relative;
`;

const FourContainer = styled(BigContainer)`
  background-color: #FFFFFF;
  width: 100%;
  position: relative;
`;

const OtherPageContainer = styled(BigContainer)`
  background-color: #FFFFFF;
  // width: 100%;
  // position: relative;
  // margin-left: 20px;
  // margin-right: 20px;
  margin: 20px;
  height: calc(100vh - 140px);
`;

const SearchingListContainer = styled(Box)`
  background-color: #FFFFFF;
  width: auto;
  // position: relative;
  // margin-left: 20px;
  // margin-right: 20px;
  margin: 20px;
  // height: calc(100vh - 300px);
  border-radius: 10px;
  overflow: auto; 
  @media (max-width: 800px) {
    /* Styles for small screens */
    margin: 10px;
  }
`;

const SearchingBoxContainer = styled(Box)`
  background-color: #FFFFFF;
  margin: 20px;
  border-radius: 10px;
  overflow: auto; 
  @media (max-width: 800px) {
    margin: 10px;
  }
`;

const FormContainer = styled(Box)`
  @media (max-width: 800px) {
    /* Styles for small screens */
    width: 100%;
  }
`;



const DateContainer = styled(Box)`
  display: flex;
  align-items: center;
  padding: 5px;
  background-color: #FFFFFF;
  width: 20%;
  border-radius: 10px;
  justify-content: justify-center;
  margin: auto;
`;

const TextxContainer = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top : 20px;
`;

const DateText = styled(Box)`
  font-weight: bold;
`;

const Heading = styled(Typography)`
  // font-weight: bold;
  // padding: 5px;
  font-size: 24px;
  margin-left: 36px;
  font-size: calc(12px + 0.35vw);
  font-family: 'Righteous';
  min-height: 4%;
`;

const ToBeCompleteHading = styled(Typography)`
  // margin-left: 12px;
  padding: 5px;
  // font-size: 24px;
  font-weight: bold;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
  font-size: calc(12px + 0.4vw); 
`;

const BigHeading = styled(Typography)`
  // font-weight: bold;
  padding: 5px;
  font-size: 24px;
  margin-left: 36px;
  font-size: calc(18px + 0.35vw);
  font-family: 'Righteous';
  min-height: 4%;
`;

const PopUpHeading = styled(Typography)`
  font-weight: bold;
  font-size: 24px;
  font-family: 'Righteous';
`;

const ToBeCompleteHeading = styled(Typography)`
  // margin-left: 12px;
  padding: 5px;
  // font-size: 24px;
  font-weight: bold;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
  font-size: calc(12px + 0.4vw); 
`;

const RemainingWorkHeading = styled(Typography)`
  margin-left: 12px;
  padding: 5px;
  // font-size: 24px;
  font-weight: bold;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
  width: auto;
  font-size: calc(12px + 0.4vw); 
  // font-family: 'Righteous';
`;

const ToDoNumber = styled(Typography)`
  // padding: 5px;
  padding-left: 10px;
  // font-size: 48px;
  // padding-left: 20px;
  font-weight: bold;
  width: auto;
  font-size: calc(12px + 1.6vw);

`;

const HousingHeading = styled(Typography)`
  color: #FAA019;
  // font-weight: bold;
  // padding: 5px;
  font-size: calc(12px + 0.6vw);
  margin-left: 10px;
  width: 4.3em;
  font-family: 'Righteous';
`;

const PrivateHeading = styled(Typography)`
  color: #00CDFF;
  // font-weight: bold;
  // padding: 5px;
  font-size: calc(12px + 0.6vw);
  margin-left: 10px;
  width: 4.3em;
  font-family: 'Righteous';
`;

const AllHeading = styled(Typography)`
  color: #F09B9B;
  // font-weight: bold;
  // padding: 5px;
  font-size: calc(12px + 0.6vw);
  margin-left: 10px;
  width: 4.3em;
  font-family: 'Righteous';
`;

const CEDDHeading = styled(Typography)`
  color: #95D330;
  // font-weight: bold;
  // padding: 5px;
  font-size: calc(12px + 0.6vw);
  margin-left: 10px;
  width: 4.3em;
  font-family: 'Righteous';
`;


const GreenButton = styled(Button)`
  background: linear-gradient(180deg, #43B656, #E2FFA5);
  font-weight: bold;
  height:20px;
  padding: 10px;
  border-radius: 10px;
`;

const RedButton = styled(Button)`
  background: linear-gradient(180deg, #F44747, #F09B9B);
  font-weight: bold;
  height:20px;
`;


const TransparentButton = styled(Button)`
  opacity:0
`;
// const SearchField = styled(TextField)`

//   border: 2px solid #F09B9B;
//   border-radius: 10px;
//   border: none;
//   background: #FFF4F4;
// `;

const RFIDLink = styled('a')`
  color: blue;
  text-decoration: underline;
  cursor: pointer;
`;

const StyledTextField = styled(TextField)({
  // [`border-radius`]: "20px",
  [`& .${outlinedInputClasses.root} .${outlinedInputClasses.notchedOutline}`]: {
    borderColor: "#F09B9B"
  },
  [`&:hover .${outlinedInputClasses.root} .${outlinedInputClasses.notchedOutline}`]: {
    borderColor: "#F09B9B"
  },
  [`& .${outlinedInputClasses.root}.${outlinedInputClasses.focused} .${outlinedInputClasses.notchedOutline}`]: {
    borderColor: "#F09B9B"
  },
  [`& .${outlinedInputClasses.input}`]: {
    color: "#F09B9B"
  },
  [`&:hover .${outlinedInputClasses.input}`]: {
    color: "#F09B9B"
  },
  [`& .${outlinedInputClasses.root}.${outlinedInputClasses.focused} .${outlinedInputClasses.input}`]: {
    color: "#F09B9B"
  },
  [`& .${inputLabelClasses.outlined}`]: {
    color: "#F09B9B"
  },
  [`&:hover .${inputLabelClasses.outlined}`]: {
    color: "#F09B9B"
  },
  [`& .${inputLabelClasses.outlined}.${inputLabelClasses.focused}`]: {
    color: "#F09B9B"
  }
});

const StyledTextFieldForOtherPage = styled(TextField)({

  [`& .${outlinedInputClasses.root} .${outlinedInputClasses.notchedOutline}`]: {
    borderColor: "#9e9e9e"
  },
  [`&:hover .${outlinedInputClasses.root} .${outlinedInputClasses.notchedOutline}`]: {
    borderColor: "#9e9e9e"
  },
  [`& .${outlinedInputClasses.root}.${outlinedInputClasses.focused} .${outlinedInputClasses.notchedOutline}`]: {
    borderColor: "#9e9e9e"
  },
  [`& .${outlinedInputClasses.input}`]: {
    color: "#9e9e9e"
  },
  [`&:hover .${outlinedInputClasses.input}`]: {
    color: "#9e9e9e"
  },
  [`& .${outlinedInputClasses.root}.${outlinedInputClasses.focused} .${outlinedInputClasses.input}`]: {
    color: "#9e9e9e"
  },
  [`& .${inputLabelClasses.outlined}`]: {
    color: "#9e9e9e"
  },
  [`&:hover .${inputLabelClasses.outlined}`]: {
    color: "#9e9e9e"
  },
  [`& .${inputLabelClasses.outlined}.${inputLabelClasses.focused}`]: {
    color: "#9e9e9e"
  }
});

const blue = {
  100: '#DAECFF',
  200: '#b6daff',
  400: '#3399FF',
  500: '#007FFF',
  600: '#0072E5',
  900: '#003A75',
};

const grey = {
  50: '#F3F6F9',
  100: '#E5EAF2',
  200: '#DAE2ED',
  300: '#C7D0DD',
  400: '#B0B8C4',
  500: '#9DA8B7',
  600: '#6B7A90',
  700: '#434D5B',
  800: '#303740',
  900: '#1C2025',
};

const Textarea = styled(BaseTextareaAutosize)(
  ({ theme }) => `
  width: 320px;
  font-family: IBM Plex Sans, sans-serif;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  padding: 8px 12px;
  border-radius: 8px;
  color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
  background: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
  border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
  box-shadow: 0px 2px 2px ${theme.palette.mode === 'dark' ? grey[900] : grey[50]};

  &:hover {
    border-color: ${blue[400]};
  }

  &:focus {
    border-color: ${blue[400]};
    box-shadow: 0 0 0 3px ${theme.palette.mode === 'dark' ? blue[600] : blue[200]};
  }

  // firefox
  &:focus-visible {
    outline: 0;
  }
`,
);

const FlexContainer = styled('div')`
  display: flex;
  align-items: center;
  @media (max-width: 768px) {
    /* Styles for small screens */
    flex-wrap: wrap;
    
  }
`;

const Label = styled('label')`
  margin-left: 20px;
  @media (max-width: 768px) {
    /* Styles for small screens */

    flex-basis:100%
  }
`;

const DatePickerContainer = styled('div')`
  display: flex;
  @media (max-width: 768px) {
    /* Styles for small screens */
    flex-basis:100%
  }

`;

const StyledHeaderCell = styled('div')`
  max-width: 350px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const StyledCell = styled('div')`
  max-width: 350px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export {
  SidebarContainer,
  SidebarContainerItem,
  inactiveStyle,
  NavigationContainer,
  NavigationToggleButton,
  NavigationSideContainer,
  NavigationSideButton,
  OverlayBaseContainer,
  OverlayActiveStyle,
  OverlayContentContainer,
  OverlayContentHeading,
  OverlayContentListItem,
  OverlayCloseLogo,
  CountdownBaseContainer,
  CountdownContainerPaddingStyle,
  BackgroundContainer,
  BigContainer,
  SmallContainer,
  LongContainer,
  ListContainer,
  RemainingContainer,
  NGListContainer,
  ReviseContainer,
  GreenSmallContainer,
  OrangeSmallContainer,
  YellowSmallContainer,
  BlueSmallContainer,
  PinkSmallContainer,
  CEDDSmallContainer,
  FourContainer,
  DateContainer,
  DateText,
  Heading,
  PopUpHeading,
  ToBeCompleteHeading,
  RemainingWorkHeading,
  ToDoNumber,
  HousingHeading,
  PrivateHeading,
  AllHeading,
  CEDDHeading,
  GreenButton,
  RedButton,
  RFIDLink,
  StyledTextField,
  Textarea,
  CloseLogo as ReviseTestResultCloseLogo,
  SelectSidebarContainerItem,
  BigHeading,
  OtherPageContainer,
  TextxContainer,
  StyledTextFieldForOtherPage,
  SearchingBoxContainer,
  SearchingListContainer,
  FormContainer,
  // SearchBoxContainer,
  FlexContainer,
  Label,
  DatePickerContainer,
  StyledHeaderCell,
  StyledCell,
  OverlayEditContentContainer,
  TestResultContainer,
  TransparentButton
};